import { createApi } from '@reduxjs/toolkit/query/react'
import { BACKEND_API_URL, urlApi } from '../consts/api'
import { extractResponseData, extractResponseError, fetchBaseQueryWithToken } from '../utils/api'
import type { TDictionaryItem } from './types'

const unwrapList = (response: unknown): TDictionaryItem[] => {
  const raw = extractResponseData(response)
  return Array.isArray(raw) ? (raw as TDictionaryItem[]) : []
}

export const dictionariesApi = createApi({
  reducerPath: 'dictionariesApi',
  baseQuery: fetchBaseQueryWithToken(BACKEND_API_URL),
  endpoints: (builder) => ({
    getCompetenciesDictionary: builder.query<TDictionaryItem[], void>({
      query: () => ({ url: `/${urlApi.competencies}` }),
      transformResponse: unwrapList,
      transformErrorResponse: extractResponseError,
    }),
    getImprovementsDictionary: builder.query<TDictionaryItem[], void>({
      query: () => ({ url: `/${urlApi.improvements}` }),
      transformResponse: unwrapList,
      transformErrorResponse: extractResponseError,
    }),
    getResourcesDictionary: builder.query<TDictionaryItem[], void>({
      query: () => ({ url: `/${urlApi.resources}` }),
      transformResponse: unwrapList,
      transformErrorResponse: extractResponseError,
    }),
    getParticipationsDictionary: builder.query<TDictionaryItem[], void>({
      query: () => ({ url: `/${urlApi.participations}` }),
      transformResponse: unwrapList,
      transformErrorResponse: extractResponseError,
    }),
    getFocusesDictionary: builder.query<TDictionaryItem[], void>({
      query: () => ({ url: `/${urlApi.focuses}` }),
      transformResponse: unwrapList,
      transformErrorResponse: extractResponseError,
    }),
  }),
})

export const {
  useGetCompetenciesDictionaryQuery,
  useGetImprovementsDictionaryQuery,
  useGetResourcesDictionaryQuery,
  useGetParticipationsDictionaryQuery,
  useGetFocusesDictionaryQuery,
} = dictionariesApi
